import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=98344f10&scoped=true&"
import script from "./Login.ts?vue&type=script&lang=ts&"
export * from "./Login.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98344f10",
  null
  
)

export default component.exports
import {QInput,QIcon,QBtn} from 'quasar'
component.options.components = Object.assign({QInput,QIcon,QBtn}, component.options.components || {})
